import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
class ProfileAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "getFullUserProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => Promise.all([
                this.getUserProfileData(),
                this.getUserPermissionsData()
            ])
        });
        Object.defineProperty(this, "getUserProfileData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.privateRequest('get', 'users/profile')
        });
        Object.defineProperty(this, "getUserPermissionsData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.privateRequest('get', 'permission')
        });
        Object.defineProperty(this, "getDealers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.privateRequest('get', 'users/dealers')
        });
        Object.defineProperty(this, "setMainDealer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (dealerId) => this.privateRequest('put', `users/dealers/${dealerId}/main`)
        });
        Object.defineProperty(this, "getCountries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lang = 'en') => this.privateRequest('get', `countries?_locale=${lang}`, {}, { 'Accept-Language': lang })
        });
        Object.defineProperty(this, "updateUserProfileData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('patch', 'users/profile', data)
        });
        Object.defineProperty(this, "removeDeliveryAddressData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => this.privateRequest('patch', 'users/profile', { deliveryAddressesForDelete: [id] })
        });
        Object.defineProperty(this, "createUserProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('post', 'users', data)
        });
        Object.defineProperty(this, "createUpdateUserProfileWithHelpSaleAgent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('post', 'edit-users-contact-form', data)
        });
        Object.defineProperty(this, "createUserProfileWithoutPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('post', 'contact-form-users', data)
        });
        Object.defineProperty(this, "updateUserProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('patch', 'contact-form-users', data)
        }); // { ...data, userAddress: { ...data.userAddress, phoneMain: '111456', firstName: 'firstName11', lastName: 'lastName11' } });
        Object.defineProperty(this, "updateUserProfileBaseInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('post', 'base-contact-info', data)
        }); // { userAddress: { firstName: 'string', lastName: 'string', gender: 0, phoneMain: 'string', } });
        Object.defineProperty(this, "updateUserProfileAdditionalAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('post', 'additional-address', data)
        }); // { userAddress: { street: 'string', number: 'string', city: 'string', zip: 'string', } });
        Object.defineProperty(this, "updateUserPermissionData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, permissionText) => {
                let requestData = data;
                if (permissionText) {
                    requestData = { permissionText, ...data };
                }
                return this.privateRequest('patch', 'permission', requestData);
            }
        });
        Object.defineProperty(this, "getApiPartners", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.privateRequest('get', 'api-partners')
        });
        Object.defineProperty(this, "getPlatforms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.privateRequest('get', 'users/platform')
        });
        Object.defineProperty(this, "addPlatform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('post', 'users/platform', data)
        });
        Object.defineProperty(this, "changePlatform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (configId, data) => this.privateRequest('patch', `users/platform/${configId}`, data)
        });
        Object.defineProperty(this, "deletePlatform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (configId) => this.privateRequest('delete', `users/platform/${configId}`)
        });
        Object.defineProperty(this, "getDealerProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.privateRequest('get', 'dealers')
        });
        Object.defineProperty(this, "getDealerProfileCheckout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => this.privateRequest('get', `dealers/${id}/info`)
        });
        Object.defineProperty(this, "createDealerProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, permissionText) => this.privateRequest('post', 'dealers', { permissionText, ...data })
        });
        Object.defineProperty(this, "putDealerProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, permissionText) => this.privateRequest('put', 'dealers', { permissionText, ...data })
        });
        Object.defineProperty(this, "changePassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (oldPassword, newPassword) => {
                const data = {
                    current_password: oldPassword,
                    password: newPassword
                };
                return this.privateRequest('put', 'users/password/change', data);
            }
        });
        Object.defineProperty(this, "changeEmail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (newEmail) => this.privateRequest('patch', 'users/profile', { email: newEmail })
        });
        Object.defineProperty(this, "getDealerUserList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (page, limit, search) => this.privateRequest('get', `dealer/user/list`, { page, limit, search })
        });
        Object.defineProperty(this, "getDealerUserData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userId) => this.privateRequest('get', `dealer/user/${userId}`)
        });
        Object.defineProperty(this, "createDealerUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userData) => this.privateRequest('post', 'dealer/user', { ...userData })
        });
        Object.defineProperty(this, "editDealerUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, userData) => this.privateRequest('patch', `dealer/user/${id}`, { ...userData })
        });
        Object.defineProperty(this, "deleteDealerUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userId) => this.privateRequest('delete', `dealer/user/${userId}`)
        });
        Object.defineProperty(this, "verifyUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (email, password) => this.privateRequest('post', 'users/verify', { email, password })
        });
        Object.defineProperty(this, "getDealerGTC", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lng) => this.request('get', `gtc/${lng}`)
        });
        Object.defineProperty(this, "disableProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (token) => this.privateRequest('post', 'disable-account', {}, { 'Authorization': `Bearer ${token}` })
        });
        this.setConfig(config);
    }
}
export default new ProfileAPI({
    baseURL: config.profileAPI.url
});
